/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Icon } from 'sarsaparilla';
import { Link } from 'react-router';
import axios from 'axios';
import { getGatewayUrl } from 'shared-ui/utils/getGatewayUrl';

import PermitMap from 'ui-permit/src/shared/components/PermitMap';

const propTypes = {
    division: PropTypes.shape({
        description: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    permitDate: PropTypes.string,
    permitId: PropTypes.string,
    permitName: PropTypes.string,
    permitType: PropTypes.string,
};

const defaultProps = {
    division: {
        id: '',
        name: '',
    },
    permitName: '',
};

export default class DivisionDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            points: null,
        };
    }

    componentDidMount() {
        axios
            .get(`/shared/boundarywaters/data/233396/features.json`, {
                credentials: 'include',
            })
            .then((json) => {
                this.setState({
                    points: json.data.points,
                });
            })
            .catch(() => {});
    }

    backToDetailedAvailability() {
        let uri = `/permits/${this.props.permitId}/registration/detailed-availability?`;

        if (this.props.permitType) {
            uri += `type=${this.props.permitType}`;
        }

        if (this.props.permitDate) {
            uri += `&date=${this.props.permitDate}`;
        }

        return uri;
    }

    renderDivisionBreadcrumb() {
        const path = [
            { title: 'Home', url: '/' },
            { title: 'Superior National Forest', url: getGatewayUrl('1085') },
            { title: 'Boundary Waters Canoe Area Wilderness', url: '/permits/233396' },
            { title: 'Detailed Availability', url: this.backToDetailedAvailability() },
            { title: this.props.division.name },
        ];

        return <Breadcrumbs path={path} />;
    }

    renderDivisionDesc() {
        return (
            <div>
                <h1>{this.props.division.name}</h1>
                <div id="division-permit-name">{this.props.permitName}</div>
                <div className="permit-division-description" id="division-permit-desc">
                    {this.props.division.description}
                </div>
            </div>
        );
    }

    renderDivisionHeader() {
        return (
            <div className="permit-division-back-link">
                <Link to={this.backToDetailedAvailability()}>
                    <Icon iconName="arrow-back" /> Back to Detailed Availability
                </Link>
            </div>
        );
    }

    renderDivisionMap() {
        const division = this.props.division;
        const points = this.state.points;

        if (division && division.id && points) {
            let divisionId = division.id;
            let geoJson = null;

            if (typeof divisionId !== 'string') {
                divisionId = `${divisionId}`;
            }

            for (let i = 0; i < points.features.length; i += 1) {
                const feature = points.features[i];
                let featureId = feature.properties.id;

                if (typeof featureId !== 'string') {
                    featureId = `${featureId}`;
                }

                if (divisionId === featureId) {
                    geoJson = {
                        features: [feature],
                        type: 'FeatureCollection',
                    };
                    break;
                }
            }

            if (geoJson) {
                return (
                    <div className="permit-division-map" id="map">
                        <PermitMap
                            center={geoJson.features[0].geometry.coordinates}
                            fullscreenControl={false}
                            geoJsonPoints={geoJson}
                            mapContainer="map"
                            zoom={17}
                        />
                    </div>
                );
            }
        }

        return null;
    }

    render() {
        return (
            <div className="permit-content-outer-wrap">
                <section className="permit-content-main division-details-container">
                    {this.renderDivisionBreadcrumb()}
                    {this.renderDivisionHeader()}
                    {this.renderDivisionDesc()}
                    {this.renderDivisionMap()}
                </section>
            </div>
        );
    }
}

DivisionDetail.propTypes = propTypes;
DivisionDetail.defaultProps = defaultProps;
